import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from '../../components/button';
import WhiteContainer from '../../components/containers/WhiteContainer';
import Icon from '../../components/icon/Icon';
import Page from '../../components/page/Page';
import routes from '../../routes/constants';
import text from '../../text';
var DEFAULT_STATE = {
    title: text('requestForQuoteSuccessTitle'),
    description: text('requestForQuoteSuccessMessage')
};
var StatusPage = function() {
    var history = useHistory();
    var location = useLocation();
    var _ref = location.state || DEFAULT_STATE, title = _ref.title, description = _ref.description;
    return /*#__PURE__*/ React.createElement(Page, {
        className: "StatusPage PageCenter"
    }, /*#__PURE__*/ React.createElement(WhiteContainer, {
        className: "p-5"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column align-items-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "icon-container success d-flex flex-row rounded-circle justify-content-center align-items-center"
    }, /*#__PURE__*/ React.createElement(Icon, {
        icon: "tick"
    })), /*#__PURE__*/ React.createElement("p", {
        className: "title text-center"
    }, title), /*#__PURE__*/ React.createElement("p", {
        className: "description text-center"
    }, description), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex justify-content-center"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: function() {
            return history.push(routes.dashboard);
        }
    }, text('goToDashboard'))))));
};
export default StatusPage;
